import React from "react";
import { Form, Col, Row, Card } from "react-bootstrap";

import ConfidentialityAgreementPDF from "../../../util/Assets/ConfidentialityAgreement.pdf";
import { getFormattedDate, getFullName } from "../../../util/helpers";
import { getDeclarationPlace } from "../../../util/onBoardingDataFilters";
import useValidation from "../../../util/useValidation";

const ConfidentialityAgreement = ({
  personalDetails,
  updatePersonalDetails
}) => {
  const { handleOnBlurValidation, errors } = useValidation();

  const handleOnBlurInput = e => {
    handleOnBlurValidation(e);
  };

  const {
    declarationDate,
    declarationPlace,
    isConfidentialAgreement
  } = personalDetails

  return (
    <Card>
      <Card.Header className="text-center">
        Confidentiality Agreement
      </Card.Header>
      <Card.Body>
        <p>
          The Manager
          <br />
          Human Resources
          <br />
          CDK Global (India) Private Limited
        </p>
        <p>
          I hereby affirm and acknowledge that I am over the age of eighteen
          (18) and under no legal disability that would prevent me from
          testifying in regard to the matters contained within this agreement.
          Further, this agreement is being made out of my free consent, volition
          and without coercion and undue influence of any kind. I have read and
          understood each and every provisions, and signs it voluntarily and
          knowingly the below agreements;
        </p>
        <ol>
          <li>Confidential Information</li>
          <li>Data Privacy : It’s a Matter of Trust</li>
          <li>Protecting Intellectual Property</li>
        </ol>
        <Form.Group
          as={Row}
          className="justify-content-start ml-2"
          controlId="isConfidentialFileDownloaded"
        >
          <Form.Check
            checked={isConfidentialAgreement}
            className="confidential-agreement-download-checkbox"
            isInvalid={errors.isConfidentialAgreement}
            name="isConfidentialAgreement"
            onBlur={handleOnBlurInput}
            onChange={evt =>
              updatePersonalDetails(
                "isConfidentialAgreement",
                evt.target.checked,
                "",
                "",
                evt.target.type
              )
            }
            required
            size="lg"
            type="checkbox"
          ></Form.Check>
          <p className="mb-0 text-danger">
            {"I agree to abide by the terms of these "}
            <a
              href={ConfidentialityAgreementPDF}
              download="Confidentiality Agreement.pdf"
            >
              Agreements
            </a>
            .
          </p>
          {errors.isConfidentialAgreement && (
            <Form.Control.Feedback type="invalid">
              {errors.isConfidentialAgreement.type === "required" &&
                "Confidential Agreement is required"}
            </Form.Control.Feedback>
          )}
        </Form.Group>

        <Form.Group as={Row} controlId="signature">
          <Form.Label column sm={2}>
            Signature*
          </Form.Label>
          <Col sm={4}>
            <Form.Control
              size="sm"
              required
              placeholder="Signature"
              type="text"
              name="signature"
              value={getFullName(personalDetails)}
              disabled
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row} controlId="name">
          <Form.Label column sm={2}>
            Name*
          </Form.Label>
          <Col sm={4}>
            <Form.Control
              size="sm"
              required
              placeholder="Name"
              type="text"
              name="name"
              value={getFullName(personalDetails)}
              disabled
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row} controlId="date">
          <Form.Label column sm={2}>
            Date*
          </Form.Label>
          <Col sm={4}>
            <Form.Control
              size="sm"
              required
              placeholder="Date"
              type="date"
              name="date"
              value={getFormattedDate(
                declarationDate,
                undefined,
                "YYYY-MM-DD"
              )}
              disabled
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row} controlId="place">
          <Form.Label column sm={2}>
            Place*
          </Form.Label>
          <Col sm={4}>
            <Form.Control
              size="sm"
              required
              placeholder="Place"
              type="text"
              name="declarationPlace"
              value={getDeclarationPlace(declarationPlace)}
              disabled
            />
          </Col>
        </Form.Group>
      </Card.Body>
    </Card>
  );
};

export default ConfidentialityAgreement;
